import classNames from "classnames"
import React from "react";
import {
  root,
  l,
  xxs,
  xs,
  s,
  xxl,
  bold,
  xl,
  m,
  center,
  none,
  blue,
  left,
  pink,
  green,
  large,
  gray,
  black,
  right,
  white,
  small,
  xlarge,
  justify,
  lightgray,
  medium
} from "./text.module.scss";

interface Props {
  className?: string
  children: React.ReactNode
  bold?: boolean
  size?:  "xxs" |"xs" | "s" | "m" | "l" | "xl" | "xxl"
  lineHeight?: "small" | "medium" | "large" | "xlarge"
  color?: "black" | "gray" | "lightgray" | "green" | "blue" | "pink" | "white"
  align?: "center" | "justify" | "right" | "left"
  margin?: "none"
}

export default React.memo((props: Props) => {
  const { className, children, size, bold: boldValue, lineHeight, color, align, margin } = props
  const classes = classNames(
    root,
    {
      [bold]: boldValue,
      [xxs]: size === "xxs",
      [xs]: size === "xs",
      [s]: size === "s",
      [m]: size === "m",
      [l]: size === "l",
      [xl]: size === "xl",
      [xxl]: size === "xxl",
      [small]: lineHeight === "small",
      [medium]: lineHeight === "medium",
      [large]: lineHeight === "large",
      [xlarge]: lineHeight === "xlarge",
      [black]: color === "black",
      [gray]: color === "gray",
      [lightgray]: color === "lightgray",
      [green]: color === "green",
      [blue]: color === "blue",
      [pink]: color === "pink",
      [white]: color === "white",
      [center]: align === "center",
      [justify]: align === "justify",
      [right]: align === "right",
      [left]: align === "left",
      [none]: margin === "none",
    },
    className
  )

  return (
    <p className={classes}>{children}</p>
  )
});
